import { getApiBaseUrl } from './apiBaseCore';
export { getApiBaseUrl, type ApiBaseUrlOptions } from './apiBaseCore';

export const API_BASE_URL = getApiBaseUrl();
